import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import SideBar from "../Components/SideBar";
import {
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    TextField,
    Typography,
    Box
} from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useFormik } from "formik";
import * as Yup from 'yup';
import BASEURL from "../Connection/BASEURL";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";

const EditDeceased = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [deceasedData, setDeceasedData] = useState(null);
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const tblid = location.state?.id;

    const GenderArray = ["Male", "Female"];
    const Religion = ["Muslim", "Christian", "Other"];

    useEffect(() => {
        if (tblid) {
            fetchDeceasedData();
        } else {
            setError('No deceased ID provided');
        }
    }, [tblid]);

    const fetchDeceasedData = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await axios.get(`${BASEURL}/deceased/${tblid}`);
            setDeceasedData(response.data);
            toast.success('Deceased data loaded successfully!', { position: toast.POSITION.TOP_CENTER });
        } catch (error) {
            console.log('Error fetching deceased data:', error);
            setError('Failed to load deceased data');
            toast.error('Failed to load deceased data', { position: toast.POSITION.TOP_CENTER });
        } finally {
            setLoading(false);
        }
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            fname: deceasedData?.fname || '',
            mname: deceasedData?.mname || "",
            lname: deceasedData?.lname || "",
            gender: deceasedData?.gender || "",
            dob: deceasedData?.dob ? dayjs(deceasedData.dob) : null,
            dod: deceasedData?.dod ? dayjs(deceasedData.dod) : null,
            placeofdeath: deceasedData?.placeofdeath || "",
            occupation: deceasedData?.occupation || "",
            religion: deceasedData?.religion || "",
            nameofwitness: deceasedData?.nameofwitness || "",
            daddressofwitness: deceasedData?.daddressofwitness || "",
            phoneofwitness: deceasedData?.phoneofwitness || "",
            dobrial: deceasedData?.dobrial ? dayjs(deceasedData.dobrial) : null,
            Aged: deceasedData?.Aged || ""
        },
        validationSchema: Yup.object({
            fname: Yup.string().required('First Name is required'),
            lname: Yup.string().required('Last Name is required'),
            mname: Yup.string().optional(),
            gender: Yup.string().required('Gender is required'),
            dob: Yup.date().required('Date of Birth is required'),
            dod: Yup.date().required('Date of Death is required'),
            occupation: Yup.string().optional(),
            religion: Yup.string().optional(),
            nameofwitness: Yup.string().optional(),
            daddressofwitness: Yup.string().optional(),
            phoneofwitness: Yup.string()
                .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits').optional(),
            dobrial: Yup.date().optional(),
            Aged: Yup.string().optional()
        }),
        onSubmit: async (values) => {
            try {
                setSubmitting(true);
                const payload = {
                    fname: values.fname,
                    mname: values.mname,
                    lname: values.lname,
                    gender: values.gender,
                    dob: values.dob ? dayjs(values.dob).format('YYYY-MM-DD') : null,
                    dod: values.dod ? dayjs(values.dod).format('YYYY-MM-DD') : null,
                    placeofdeath: values.placeofdeath,
                    occupation: values.occupation,
                    religion: values.religion,
                    nameofwitness: values.nameofwitness,
                    daddressofwitness: values.daddressofwitness,
                    phoneofwitness: values.phoneofwitness,
                    dobrial: values.dobrial ? dayjs(values.dobrial).format('YYYY-MM-DD') : null,
                    Aged: values.Aged
                };

                const response = await axios.put(`${BASEURL}/deceased/${tblid}`, payload);
                
                if (response.data) {
                    toast.success('Deceased information updated successfully!', {
                        position: toast.POSITION.TOP_CENTER
                    });
                    navigate('/all-deceased');
                }
            } catch (error) {
                console.log('Error updating deceased data:', error);
                toast.error('Failed to update deceased information', {
                    position: toast.POSITION.TOP_CENTER
                });
            } finally {
                setSubmitting(false);
            }
        }
    });

    if (loading) {
        return (
            <>
                <ToastContainer />
                <div className='grid grid-cols-12'>
                    <div className='col-span-2 hidden lg:block'>
                        <SideBar />
                    </div>
                    <div className='col-span-12 lg:col-span-10 bg-[#D2D2CF]'>
                        <Header />
                        <div className="flex items-center justify-center min-h-screen">
                            <Box className="text-center">
                                <CircularProgress size={60} style={{ color: "#0F1D48" }} />
                                <Typography variant="h6" className="mt-4 text-[#0F1D48]">
                                    Loading deceased data...
                                </Typography>
                            </Box>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <ToastContainer />
                <div className='grid grid-cols-12'>
                    <div className='col-span-2 hidden lg:block'>
                        <SideBar />
                    </div>
                    <div className='col-span-12 lg:col-span-10 bg-[#D2D2CF]'>
                        <Header />
                        <div className="flex items-center justify-center min-h-screen">
                            <Box className="text-center">
                                <Typography variant="h6" className="text-red-600">
                                    {error}
                                </Typography>
                                <Button 
                                    onClick={() => navigate('/all-deceased')}
                                    variant="contained"
                                    style={{ backgroundColor: "#0F1D48", color: "white", marginTop: 16 }}
                                >
                                    Back to All Deceased
                                </Button>
                            </Box>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <ToastContainer />
            <div className='grid grid-cols-12'>
                <div className='col-span-2 hidden lg:block'>
                    <SideBar />
                </div>
                <div className='col-span-12 lg:col-span-10 bg-[#D2D2CF]'>
                    <Header />
                    <div className="px-6 py-6">
                        <div className="flex items-center justify-between mb-6">
                            <h1 className="text-2xl lg:text-4xl font-bold text-[#111927] py-2">
                                Edit Deceased Information
                            </h1>
                            <Button 
                                onClick={() => navigate('/all-deceased')}
                                variant="contained"
                                style={{ backgroundColor: "#6B7280", color: "white" }}
                            >
                                Back to All Deceased
                            </Button>
                        </div>

                        <Paper elevation={3} className="bg-white p-6" style={{ borderRadius: 20 }}>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                    <TextField
                                        fullWidth
                                        placeholder="First Name"
                                        label="First Name"
                                        id="fname"
                                        name="fname"
                                        variant="outlined"
                                        {...formik.getFieldProps('fname')}
                                        error={formik.touched.fname && Boolean(formik.errors.fname)}
                                        helperText={formik.touched.fname && formik.errors.fname}
                                    />
                                    <TextField
                                        fullWidth
                                        placeholder="Middle Name"
                                        label="Middle Name"
                                        id="mname"
                                        name="mname"
                                        variant="outlined"
                                        {...formik.getFieldProps('mname')}
                                        error={formik.touched.mname && Boolean(formik.errors.mname)}
                                        helperText={formik.touched.mname && formik.errors.mname}
                                    />
                                    <TextField
                                        fullWidth
                                        placeholder="Last Name"
                                        label="Last Name"
                                        id="lname"
                                        name="lname"
                                        variant="outlined"
                                        {...formik.getFieldProps('lname')}
                                        error={formik.touched.lname && Boolean(formik.errors.lname)}
                                        helperText={formik.touched.lname && formik.errors.lname}
                                    />
                                    <FormControl fullWidth>
                                        <InputLabel id="gender-select-label">Select Gender</InputLabel>
                                        <Select
                                            label="gender"
                                            name="gender"
                                            value={formik.values.gender}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.gender && Boolean(formik.errors.gender)}
                                        >
                                            {GenderArray.map((list) => (
                                                <MenuItem key={list} value={list}>{list}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.gender && formik.errors.gender ? (
                                            <div className="error pt-1">
                                                <p className="text-xs text-[#D32F2F]">{formik.errors.gender}</p>
                                            </div>
                                        ) : null}
                                    </FormControl>
                                    
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            format="YYYY-MM-DD"
                                            label="Date of Birth"
                                            name="dob"
                                            value={formik.values.dob}
                                            onChange={(date) => {
                                                formik.setFieldValue('dob', date);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                            error={formik.touched.dob && Boolean(formik.errors.dob)}
                                            helperText={formik.touched.dob && formik.errors.dob}
                                        />
                                    </LocalizationProvider>
                                    
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            format="YYYY-MM-DD"
                                            label="Date of Death"
                                            name="dod"
                                            value={formik.values.dod}
                                            onChange={(date) => {
                                                formik.setFieldValue('dod', date);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                            error={formik.touched.dod && Boolean(formik.errors.dod)}
                                            helperText={formik.touched.dod && formik.errors.dod}
                                        />
                                    </LocalizationProvider>
                                    
                                    <TextField
                                        fullWidth
                                        label="Place of Death"
                                        placeholder="Place of Death"
                                        id="placeofdeath"
                                        name="placeofdeath"
                                        variant="outlined"
                                        {...formik.getFieldProps('placeofdeath')}
                                        error={formik.touched.placeofdeath && Boolean(formik.errors.placeofdeath)}
                                        helperText={formik.touched.placeofdeath && formik.errors.placeofdeath}
                                    />
                                    <TextField
                                        fullWidth
                                        label="Occupation"
                                        placeholder="Occupation"
                                        id="occupation"
                                        name="occupation"
                                        variant="outlined"
                                        {...formik.getFieldProps('occupation')}
                                        error={formik.touched.occupation && Boolean(formik.errors.occupation)}
                                        helperText={formik.touched.occupation && formik.errors.occupation}
                                    />
                                    <FormControl fullWidth>
                                        <InputLabel id="religion-select-label">Select Religion</InputLabel>
                                        <Select
                                            labelId="religion-select-label"
                                            name="religion"
                                            value={formik.values.religion}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.religion && Boolean(formik.errors.religion)}
                                        >
                                            {Religion.map((list) => (
                                                <MenuItem key={list} value={list}>{list}</MenuItem>
                                            ))}
                                        </Select>
                                        {formik.touched.religion && formik.errors.religion ? (
                                            <div className="error pt-1">
                                                <p className="text-xs text-[red]">{formik.errors.religion}</p>
                                            </div>
                                        ) : null}
                                    </FormControl>
                                    
                                    <TextField
                                        fullWidth
                                        label="Name of Witness"
                                        placeholder="Name of Witness"
                                        id="nameofwitness"
                                        name="nameofwitness"
                                        variant="outlined"
                                        {...formik.getFieldProps('nameofwitness')}
                                        error={formik.touched.nameofwitness && Boolean(formik.errors.nameofwitness)}
                                        helperText={formik.touched.nameofwitness && formik.errors.nameofwitness}
                                    />
                                    <TextField
                                        fullWidth
                                        label="Address of Witness"
                                        placeholder="Address of Witness"
                                        id="daddressofwitness"
                                        name="daddressofwitness"
                                        variant="outlined"
                                        {...formik.getFieldProps('daddressofwitness')}
                                        error={formik.touched.daddressofwitness && Boolean(formik.errors.daddressofwitness)}
                                        helperText={formik.touched.daddressofwitness && formik.errors.daddressofwitness}
                                    />
                                    <TextField
                                        fullWidth
                                        label="Phone number of witness"
                                        placeholder="Phone number of witness"
                                        id="phoneofwitness"
                                        name="phoneofwitness"
                                        variant="outlined"
                                        {...formik.getFieldProps('phoneofwitness')}
                                        error={formik.touched.phoneofwitness && Boolean(formik.errors.phoneofwitness)}
                                        helperText={formik.touched.phoneofwitness && formik.errors.phoneofwitness}
                                    />
                                    
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Date of burial"
                                            format="YYYY-MM-DD"
                                            name="dobrial"
                                            value={formik.values.dobrial}
                                            onChange={(date) => {
                                                formik.setFieldValue('dobrial', date);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                            error={formik.touched.dobrial && Boolean(formik.errors.dobrial)}
                                            helperText={formik.touched.dobrial && formik.errors.dobrial}
                                        />
                                    </LocalizationProvider>
                                    
                                    <TextField
                                        type="number"
                                        fullWidth
                                        label="Age of deceased"
                                        placeholder="Age of deceased"
                                        id="Aged"
                                        name="Aged"
                                        variant="outlined"
                                        {...formik.getFieldProps('Aged')}
                                        error={formik.touched.Aged && Boolean(formik.errors.Aged)}
                                        helperText={formik.touched.Aged && formik.errors.Aged}
                                    />
                                </div>
                                
                                <div className="flex justify-end items-center mt-8">
                                    {submitting ? (
                                        <Button
                                            variant="contained"
                                            style={{
                                                fontFamily: "'Poppins', sans-serif",
                                                borderRadius: 8,
                                                paddingLeft: 20,
                                                paddingRight: 20,
                                                paddingTop: 10,
                                                paddingBottom: 10,
                                                backgroundColor: "#0F1D48",
                                                color: "white",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            <CircularProgress size={17} style={{ color: "white" }} />
                                        </Button>
                                    ) : (
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            style={{
                                                fontFamily: "'Poppins', sans-serif",
                                                borderRadius: 8,
                                                paddingLeft: 20,
                                                paddingRight: 20,
                                                paddingTop: 10,
                                                paddingBottom: 10,
                                                backgroundColor: "#0F1D48",
                                                color: "white",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Update Deceased Information
                                        </Button>
                                    )}
                                </div>
                            </form>
                        </Paper>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditDeceased;
